[
  {
    "status": "incomplete",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "ContinueQuote",
        "hooks": []
      },
      {
        "code": "Abandon",
        "hooks": []
      },
      {
        "code": "Submit",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "incomplete",
    "role": "broker",
    "type": "endorsement",
    "actions": [
      {
        "code": "GetQuote",
        "hooks": []
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedRoles": [ "underlier" ]
      }
    ]
  },
  {
    "status": "abandoned",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "Recover",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "submitted",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "AcceptSubmission",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectSubmission",
        "hooks": [],
        "excludedProducts": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedProducts": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "submitted",
    "role": "broker",
    "type": "endorsement",
    "actions": [
      {
        "code": "GetQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "accepted",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "GetQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "referred",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "AcceptReferral",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectReferral",
        "hooks": []
      },
      {
        "code": "RejectSubmission",
        "hooks": [],
        "applicableProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoted",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "ReQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "IssueQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoteIssued",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "RequestBind",
        "hooks": [],
        "excludedProducts": [ "ppackage", "securemyoffer" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoteAccepted",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "RequestBind",
        "hooks": [],
        "excludedProducts": [ "ppackage", "securemyoffer" ]
      },
      {
        "code": "IssueQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectReferral",
        "hooks": []
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "bindRequested",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "ConfirmBind",
        "hooks": [],
        "excludedProducts": [ "ppackage" ],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance", "securemyoffer" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "bound",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "Issue",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "issued",
    "role": "broker",
    "type": null,
    "actions": [
      {
        "code": "Endorse",
        "hooks": []
      }
    ]
  },
  {
    "status": "incomplete",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "ContinueQuote",
        "hooks": []
      },
      {
        "code": "Abandon",
        "hooks": []
      },
      {
        "code": "Submit",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "incomplete",
    "role": "administrator",
    "type": "endorsement",
    "actions": [
      {
        "code": "GetQuote",
        "hooks": []
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedRoles": [ "underlier" ]
      }
    ]
  },
  {
    "status": "abandoned",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "Recover",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "submitted",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "AcceptSubmission",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectSubmission",
        "hooks": [],
        "excludedProducts": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedProducts": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "submitted",
    "role": "administrator",
    "type": "endorsement",
    "actions": [
      {
        "code": "GetQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "accepted",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "GetQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "referred",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "AcceptReferral",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectReferral",
        "hooks": []
      },
      {
        "code": "RejectSubmission",
        "hooks": [],
        "applicableProducts": []
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoted",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "ReQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "IssueQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoteIssued",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "RequestBind",
        "hooks": [],
        "excludedProducts": [ "ppackage", "securemyoffer" ]
      },
      {
        "code": "ConfirmBind",
        "hooks": [],
        "MGAProducts": [ "securemyoffer" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoteIssued",
    "role": "administrator",
    "type": "endorsement",
    "actions": [
      {
        "code": "ConfirmBind",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "Lost",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "quoteAccepted",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "RequestBind",
        "hooks": [],
        "excludedProducts": [ "ppackage", "securemyoffer" ]
      },
      {
        "code": "IssueQuote",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "RejectReferral",
        "hooks": []
      },
      {
        "code": "Lost",
        "hooks": []
      },
      {
        "code": "SendPaymentLink",
        "hooks": []
      },
      {
        "code": "UnderwriterReviewLink",
        "hooks": [],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "bindRequested",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "ConfirmBind",
        "hooks": [],
        "excludedProducts": [ "ppackage" ],
        "MGAProducts": [ "sn-commercial", "sn-small-business-insurance", "securemyoffer" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "bound",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "Issue",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "ChargeCard",
        "hooks": []
      }
    ]
  },
  {
    "status": "issued",
    "role": "administrator",
    "type": null,
    "actions": [
      {
        "code": "Endorse",
        "hooks": [],
        "excludedProducts": [ "ppackage" ]
      },
      {
        "code": "Renew",
        "hooks": [
          {
            "code": "redirection",
            "value": "profile"
          }
        ],
        "excludedProducts": [ "sn-commercial", "sn-small-business-insurance" ],
        "excludedRoles": [ "underlier" ]
      },
      {
        "code": "ViewRenewalPolicy",
        "hooks": [],
        "excludedProducts": [ "sn-commercial", "sn-small-business-insurance" ]
      }
    ]
  }
]
